import React, { useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels,
);

function SectorFunnel({ chart_data }) {
  let data_labels = [];
  let datasets_data = [];

  const chart = useRef();

  if (!chart.current) {
    chart_data?.forEach((item) => {
      data_labels.push(item.name);
      datasets_data.push(item.total);
    });
  } else {
    chart.current = true;
  }

  const data = {
    labels: data_labels,
    datasets: [
      {
        data: datasets_data,
        backgroundColor: [
          "#4CAF50",
          "#2196F3",
          "#FF9800",
          "#9C27B0",
          "#E91E63",
          "#00BCD4",
          "#795548",
        ],
        borderRadius: 8,
        barThickness: 22,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          // ✅ show ONLY value on hover
          label: function (context) {
            return context.raw; // just number
          },
          title: function () {
            return ""; // ❌ remove label title
          },
        },
      },
      datalabels: {
        display: false, // prevents constant values on bars
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
        grid: {
          display: false, // ❌ remove vertical grid
        },
      },
      y: {
        grid: {
          display: false, // ❌ remove horizontal grid
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
}

export default SectorFunnel;
